import React from 'react'

import { Picture, PictureProps } from '@/atoms/Picture'
import { Stack } from '@/atoms/System'
import { UnavailablePageInfo, UnavailablePageInfoProps } from '@/atoms/UnavailablePageInfo'
import { TestId } from '@/lib/e2e-utils'
import styled, { muiUtils } from '@/styles'

interface ErrorPageBaseProps
	extends
		Partial<TestId>,
		Pick<UnavailablePageInfoProps, 'buttonsContainerSx' | 'titleSx' | 'subtitleSx' | 'contentSx'> {
	className?: string
	buttons?: React.ReactNode
	pictureProps: PictureProps
	title: string
	subtitle: string
	pageInfoContent?: React.ReactNode
}

const StyledPageInfo = styled(UnavailablePageInfo)`
	margin-top: auto;
`

const Container = styled(Stack)`
	justify-content: space-evenly;

	${muiUtils.desktop} {
		justify-content: flex-end;
	}
`

export function ErrorPageBase({
	className,
	title,
	subtitle,
	buttons,
	pictureProps,
	pageInfoContent,
	titleSx,
	subtitleSx,
	buttonsContainerSx,
	contentSx,
	...rest
}: ErrorPageBaseProps) {
	return (
		<Container className={className} data-test={rest['data-test']}>
			<StyledPageInfo
				contentSx={contentSx}
				title={title}
				subtitle={subtitle}
				buttons={buttons}
				titleSx={titleSx}
				subtitleSx={subtitleSx}
				buttonsContainerSx={buttonsContainerSx}
			>
				{pageInfoContent}
			</StyledPageInfo>

			<Picture {...pictureProps} />
		</Container>
	)
}
